import Nav from "../components/Nav.jsx";
import Footer from "../components/Footer.jsx";
import Hero from "../components/sections/Hero.jsx";
import Picker from "../components/sections/Picker.jsx";
import Trust from "../components/sections/Trust.jsx";
import Activities from "../components/sections/Activities.jsx";
import Schedule from "../components/sections/Schedule.jsx";
import Gallery from "../components/sections/Gallery.jsx";
import CampLife from "../components/sections/CampLife.jsx";
import Pricing from "../components/sections/Pricing.jsx";
import Reviews from "../components/sections/Reviews.jsx";
import FAQ from "../components/sections/FAQ.jsx";
import CrossPromo from "../components/sections/CrossPromo.jsx";
import Newsletter from "../components/sections/Newsletter.jsx";
import SkateparkSection from "../components/sections/SkateparkSection.jsx";
import ForParents from "../components/sections/ForParents.jsx";
import { useI18n } from "../lib/i18n.jsx";

export default function Home() {
  const { t } = useI18n();
  const scrollToPricing = (e) => {
    e.preventDefault();
    document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <div className="bg-cream">
      <Nav />
      <main>
        <Hero />
        <Picker />
        <Trust />
        <Activities />
        <Schedule />
        <SkateparkSection />
        <Gallery />
        <CampLife />
        <Pricing />
        <ForParents />
        <Reviews />
        <FAQ />
        <CrossPromo />
        <Newsletter />
      </main>
      <Footer />

      <div className="md:hidden fixed bottom-0 inset-x-0 z-40 mobile-cta px-3 pt-2 pb-3 bg-cream/95 backdrop-blur border-t border-winter/10" data-testid="mobile-sticky-cta">
        <a
          href="#pricing"
          onClick={scrollToPricing}
          className="btn-pill btn-pill-primary w-full justify-center py-4"
        >
          {t.nav.signup} →
        </a>
      </div>
    </div>
  );
}
